import React, { useEffect, useState } from 'react'
import ProgressBar from '../ProgressBar'
import { getSingleActiveAchievement } from '../../server/server'
import eventBus from '../../utils/EventBus'

function RewardingFeedHeader() {
    const [achievement, setAchievement] = useState(null)

    useEffect(() => {
        loadSingleAchievement()
        eventBus.on('refreshAchievement', loadSingleAchievement)
        return () => {
            eventBus.remove('refreshAchievement')
        }
    }, [])

    const loadSingleAchievement = async () => {
        const resp = await getSingleActiveAchievement()
        if (resp.status === 200) {
            setAchievement(resp.data)
        }
    }

    return !!achievement ? (
        <div className="rewarding-feed-container">
            <div className="rewarding-feed-content">
                <div style={{ minWidth: 114, height: 94 }}>
                    <img src={achievement.image} alt={achievement.name} id={achievement.image} />
                </div>
                <div className="rewarding-feed-content-text">
                    {/* #TODO translate text that is shown below from backend */}
                    <div className="rewarding-feed-content-title">{achievement.name}</div>
                    <div style={{ width: 238 }}>
                        <ProgressBar completed={achievement.progress} />
                    </div>
                </div>
            </div>
        </div>
    ) : null
}

export default RewardingFeedHeader
